export enum EntityType {
    Job = 'job',
    Skill = 'skill',
    Mentor = 'mentor',
    Project = 'project',
    Org = 'organization',
    UserProfile = 'profile', // Default user profile
    Volunteer = 'volunteer',
    CommunityProfile = 'community',
    TalentBaseProfile = 'talentbase',
    UserPrivateProfile = 'privateProfile'
}
